import banner from '../../assets/svg/thumbnailBanner/banner.svg.js';
import bannerShort from '../../assets/svg/thumbnailBanner/banner_short.svg.js';
import bannerGrey from '../../assets/svg/thumbnailBanner/banner_grey.svg.js';
import unavailableBanner from '../../assets/svg/thumbnailBanner/unavailable-banner-small.png.js';

const getBannerInfo = activityType => {
  let bannerInfo;
  switch (activityType) {
    case 'algebraTiles':
    case 'baseTenBlocks':
    case 'colorTiles':
    case 'fractionTiles':
      bannerInfo = {
        textKey: 'EXCLUSIVE_TO_NEARPOD_MATH',
        image: banner
      };
      break;
    case 'dragAndDrop':
      bannerInfo = {
        textKey: 'UPGRADE_TO_EDIT',
        image: bannerShort
      };
      break;
    case 'brainBreaks':
      bannerInfo = {
        textKey: 'EXCLUSIVE_TO_21ST_CENTURY',
        image: banner
      };
      break;
    case 'graphingCalculator':
    case 'flocabulary':
    case 'slide':
    case 'boardworks':
      bannerInfo = {
        textKey: 'TEACH_ONLY',
        image: bannerGrey
      };
      break;
    case 'flipGrid':
      bannerInfo = {
        textKey: 'UNAVAILABLE',
        image: unavailableBanner
      };
      break;
    default:
      bannerInfo = {
        textKey: 'UPGRADE_TO_EDIT',
        image: banner
      };
  }
  return bannerInfo;
};

export { getBannerInfo };
//# sourceMappingURL=getThumbnailBannerInfo.js.map
